import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faInfoCircle } from '@fortawesome/pro-regular-svg-icons/faInfoCircle'
import classNames from 'classnames'

import * as S from './styled'

const TextInput = React.forwardRef(
    (
        {
            label,
            value,
            onChange,
            tooltip,
            placeholder,
            className = '',
            wrapperClassName = '',
            ...restProps
        },
        ref
    ) => {
        const labelText = label || placeholder

        return (
            <div
                className={`form-group ${wrapperClassName}`}
                data-testid={`${labelText.toLowerCase().replaceAll(' ', '-')}-section`}
            >
                <div>
                    {label && (
                        <label className="!mb-1">
                            {label}
                            {restProps?.required && <span style={{ color: 'red' }}> *</span>}
                        </label>
                    )}
                    {tooltip && (
                        <span
                            data-tooltip={tooltip}
                            className={classNames('!ml-2', {
                                'tooltip-wrap': tooltip.length > 50,
                            })}
                        >
                            <FontAwesomeIcon icon={faInfoCircle} />
                        </span>
                    )}
                </div>

                <S.TextInput
                    type="text"
                    className={`form-control ${className}`}
                    value={value}
                    onChange={onChange}
                    ref={ref}
                    placeholder={placeholder}
                    {...restProps}
                />
            </div>
        )
    }
)

export default TextInput
